// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-button {
    background-color: #ffffff;
    color: rgb(0, 0, 0);
  
    border: 2px solid #000000;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: 15px;
    transition: background-color 0.3s ease;
  }
  
  .download-button:hover {
    background-color: #e6f3ff;
  }
  
  .details-button {
    background-color: #ffa500;
  }`, "",{"version":3,"sources":["webpack://./src/components/historyd/History.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mBAAmB;;IAEnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".download-button {\r\n    background-color: #ffffff;\r\n    color: rgb(0, 0, 0);\r\n  \r\n    border: 2px solid #000000;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-bottom: 15px;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .download-button:hover {\r\n    background-color: #e6f3ff;\r\n  }\r\n  \r\n  .details-button {\r\n    background-color: #ffa500;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
